import React from 'react';

import { FullscreenRender } from './fullscreen-render';

type FullscreenElementConstructor = React.JSXElementConstructor<string> & {
  fullscreenName: string;
};

type FullscreenElement = React.ReactElement<any, FullscreenElementConstructor>;

interface FullscreenModeProps {
  children: FullscreenElement;
}
/**
 * Extract the name of child component and pass it to fullscreen iframe for
 * rendering. We do no actual rendering of children in this component, the fact
 * that we pass real child component here serves only for robust typechecking.
 * The disadvantage of this component is lack of tree-shaking and the
 * dependencies that are necessary in the fullscreen bundle will also land in
 * the other bundle.
 *
 * Consider using the FullscreenElement component for proper tree-shaking but
 * lack of typechecking.
 */
export const FullscreenMode: React.FC<FullscreenModeProps> = ({ children }) => {
  const child = React.Children.only(children);

  if (typeof child.type === 'string') {
    throw 'Rendering of ReactText component is of little use in fullscreen';
  }

  const componentName = child.type.fullscreenName;

  if (typeof componentName !== 'string') {
    throw 'The static prop "fullscreenName" is missing in fullscreen component';
  }

  if (child.props.children) {
    /**
     * Note: we could actually implement this but it seems like this is not
     * necessary.
     */
    throw 'Deep component trees cannot be renderer in fullscreen mode.';
  }

  return <FullscreenRender componentName={componentName} allProps={child.props} />;
};
